import { graphqlPost } from "api/graphqlClient";
import NotificationService from "components/Notification/Notification.service";
import RestErrorNotification from "components/Notification/RestErrorNotification";
import { call, put, takeEvery } from "redux-saga/effects";
import { actions as wrapperListActions } from "./WrapperList.reducer";

export function* fetchWrapperListAction({ promise, params }) {
    try {
        const response = yield graphqlPost(params);
        yield put({
            type: wrapperListActions.SUCCESSFUL_FETCH_LISTING_WRAPPER_LIST,
            response,
        });
        yield call(promise.resolve);
    } catch (error) {
        yield call(promise.reject, error?.response?.data || error);
        NotificationService.error(<RestErrorNotification error={error} />);
    }
}

export function* fetchResourceWrapperListAction({ promise, params, resourceId }) {
    try {
        const response = yield graphqlPost(params);
        yield put({
            type: wrapperListActions.SUCCESSFUL_FETCH_RESOURCE_WRAPPER_LIST,
            response,
            resourceId,
        });
        yield call(promise.resolve, response?.data);
    } catch (error) {
        yield call(promise.reject, error?.response?.data || error);
        NotificationService.error(<RestErrorNotification error={error} />);
    }
}

/**
 * Register action to watcher
 */
export default [
    takeEvery(wrapperListActions.FETCH_LISTING_WRAPPER_LIST, fetchWrapperListAction),
    takeEvery(wrapperListActions.FETCH_RESOURCE_WRAPPER_LIST, fetchResourceWrapperListAction),
];
